module.exports = "body {\r\n    background: #fff !important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/terms/terms.component.css
// module id = ./src/app/terms/terms.component.css
// module chunks = main